import {XauditModel} from '../../../../models/xaudit.model';

export class AnesthesiaEndoExplosionItemConfigurationModel extends XauditModel {
  AnesthesiaEndoExplosionItemID: string;
  AnesthesiaEndoExplosionID: string;
  enumAnestQuantityID: string;
  enumAnestTypeID: string;
  enumAnestAnesthesiaID: string;
}
